var userHandles = [
    'kczno1',
    '-XraY-',
    'Um_nik',
    'tourist',
    'ecnerwala',
    'Benq',
    'boboniu',
    'maroonrk',
    'Petr',
    'ksun48',
    'TLE',
    'scott_wu',
    'Radewoosh',
    'WZYYN',
    'yosupo',
    'fateice',
    'apiadu', 
    'tEMMIE.w.',
    'SkyDec',
    'neal',
    'molamola.',
    'peehs_moorhsum',
    'Egor',
    '300iq',
    'Marcin_smu',
    'mnbvmar',
    'jiangly',
    'Merkurev',
    'hos.lyric',
    'gisp_zjz',
    'Endagorion',
    'cuizhuyefei',
    'zhouyuyang',
    'tlwpdus',
    'ko_osaga',
    'KAN',
    'ainta',
    'LHiC',
    'whzzt',
    'FizzyDavid',
    'zeronumber',
    'nick452'
];

export default userHandles;